import classNames from "classnames";

import styles from "./PageTitle.module.css";

type Props = {
  className?: string;
  children: string;
};

export default function PageTitle(props: Props) {
  return (
    <div className={classNames(styles.title, props.className)}>
      {props.children}
    </div>
  );
}
